import { component } from 'picoapp'
import $ from 'jquery'
import 'slick-carousel'

export default component(node => {
    const slider = $('[data-hero-slider]')
    const prev = $('[data-hero-prev]')
    const next = $('[data-hero-next]')

    slider.not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: prev,
        nextArrow: next,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    })
})